<h2 mat-dialog-title class="text-center">Añadir medio de contacto</h2>
<mat-dialog-content class="text-center">
  <div [formGroup]="medioForm"   style="padding: 16px">
    <div class="row">
      <!--- LINEA OBSERVACION --->
      <div class="col-12">
        <label class="form-label">Medio</label>
        <input type="text" class="form-control" formControlName="medio" >
      </div>

    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions  >
  <div class="row">
    <div class="col-1"></div>
    <div class="col-10">
      <button mat-button matDialogClose  class="aceptar float-left" >Cerrar</button>
      <button mat-button [mat-dialog-close]="medioForm" class="aceptar" [disabled]="!medioForm.valid" >Guardar</button>
    </div>
    <div class="col-1"></div>
  </div>
</mat-dialog-actions>
